import React from 'react';

import TalkBase from '../_talk';
import talk from './introduccion-polymer.json';

export default () => <TalkBase talk={talk} />;



// WEBPACK FOOTER //
// ./pages/talks/introduccion-polymer/index.js